import { makeRequest } from 'utils/requestLogger';

export default (liveID) =>
  makeRequest('get', `/api/live_discussions/${liveID}/auth/agoraRtc/`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/getAgoraRTCconnection.js